import createCache, { EmotionCache } from '@emotion/cache'

const key = 'c'

export const cache: EmotionCache = createCache({ key })
